import { File } from "./File.js";
export const isFile = (value) => value instanceof File;
